import CrudRepository from './CrudRepository'
import Repository from './Repository'
import Store from '../store'

export default class OffersByCategoryRepository extends CrudRepository {
  constructor () {
    super('core/api/offers/categories')
  }

  async getByCategory (id, page, size, lineType) {
    const search = Store.state.searchValue
    // Guest only can add lineType value in the otherwise we will add the gsm of main account as a param
    const response = await Repository.get(`${this.resource}/${id}/offers/web?page=${page}&size=${size}&search=${search}${Store.state.selectedNumber === null ? `&lineType=${lineType}` : `&gsm=${Store.state.selectedNumber}`}`)
    return response
  }
}
